// LeavesPage — thin wrapper around the canonical EmployeeLeavesPage component.
// The duplicate inline implementation (with the "exactly 5, no changes after save"
// Optional-Holiday picker) was retired as part of the Feb-2026 leaves audit
// (BUG 5). All employee-facing leave logic now lives in ONE place:
//   /app/frontend/src/components/EmployeeLeavesPage.js
import React from 'react';
import EmployeeLayout from '../../components/EmployeeLayout';
import EmployeeLeavesPage from '../../components/EmployeeLeavesPage';

export default function LeavesPage() {
  return (
    <EmployeeLayout>
      <EmployeeLeavesPage />
    </EmployeeLayout>
  );
}
